// extracted by mini-css-extract-plugin
module.exports = {"root":"LottieAnimation-module--root--3WQXk","placeholder":"LottieAnimation-module--placeholder--2SRGa"};